import { useNavigate } from "react-router-dom";
import { Pagination } from "../../Components";
import React, { useState } from "react";
import SelectWayToDataCollectionCreate from "./SelectWayToDataCollectionCreate";

const tableData = [
  {
    id: 1,
    name: "Leanne Graham",
    Bio: "Traveler & foodie",
    Country: "India",
    handle: "LeanneGraham",
  },
  {
    id: 2,
    name: "John Doe",
    Bio: "Frontend Developer passionate about React.",
    Country: "USA",
    handle: "john_doe",
  },
  {
    id: 3,
    name: "Maria Rossi",
    Bio: "Traveler & foodie sharing experiences.",
    Country: "Italy",
    handle: "mariaR",
  },
  {
    id: 4,
    name: "Akira Tanaka",
    Bio: "AI researcher and open-source contributor.",
    Country: "Japan",
    handle: "akira_t",
  },
  {
    id: 5,
    name: "Sofia Almeida",
    Bio: "Digital artist creating minimalist designs.",
    Country: "Brazil",
    handle: "sofiaalmeida",
  },
  {
    id: 6,
    name: "David Smith",
    Bio: "Entrepreneur & coffee lover.",
    Country: "UK",
    handle: "david_smith",
  },
];

export const DataCollection = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleDataCollectionSelection = (e) => {
    e.stopPropagation();
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  return (
    <div className="mt-4">
      <div className="flex justify-end mb-4">
        <button
          className="px-4 py-3 bg-gradient-to-r from-emerald-500 to-green-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
          onClick={handleDataCollectionSelection}
        >
          Add DataCollection
        </button>
      </div>
      <div className="admnotif__table !rounded-xl">
        <table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Bio</th>
              <th>Country</th>
              <th>Handle</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 &&
              tableData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.Bio}</td>
                    <td>{item.Country}</td>
                    <td>{item.handle}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end">
        <Pagination
          perPage={10} 
          total={42} 
          currentPage={1} 
          totalPages={Math.ceil(42 / 10)} 
          onPaginate={(page) => {
            console.log("Switched to page:", page);
          }}
        />
      </div>
      {isPopupOpen && <SelectWayToDataCollectionCreate onClose={closePopup} />}
    </div>
  );
};
